import { isTokenValid } from "@/helpers";
import { useFetch } from "nuxt/app";
// import FingerprintJS from '@fingerprintjs/fingerprintjs'

export default async function makeServerRequest({
  url,
  includeUserToken = false,
  includeUID = false,
  headerOptions = {}
}) {
  // NOTE: this composable is used only for the User role as a GET request, and runs on the server-side.
  const config = useRuntimeConfig();
  let baseURL =
    process.env.NODE_ENV === "development"
      ? config.public.dev_base
      : config.public.prod_base;
  const cookieStorage = useCookie("localStorageCopy")?.value;
  let cookieUID = useCookie("UID");

  if(includeUID && !cookieUID?.value){
    // const fpPromise = FingerprintJS?.load();
    // fpPromise?.then(fp => fp.get())
    // .then(result => {
    //   cookieUID.value = result.visitorId;
    // })
  }

  const userToken = cookieStorage?.user?.token;

  const isAuthenticated = includeUserToken
    ? userToken && isTokenValid(userToken)
    : false;
  const isUIDIncluded = includeUID ? cookieUID?.value : false;

  return await useFetch(`${baseURL}/${url}`, {
    onRequest({ request, options }) {
      options.headers = {
        Accept: "application/json",
        Platform: "web",
        "Accept-Language": cookieStorage?.language || "ar",
        ...(isAuthenticated && {
          Authorization: `Bearer ${userToken}`,
        }),
        ...(isUIDIncluded && {
          'UID': cookieUID.value,
        }),
        ...(headerOptions && {...headerOptions})
      };
    },
  });
}
